import i18n from '~/i18n';
import { checkDuplicated } from '~/utils';

const validateRequired = (value) => {
  if (value === null || value === undefined || String(value).trim() === '') {
    return { isValid: false, helperText: i18n.t('validation:RequiredField') };
  }
  return null;
};

const validateMaxLength64 = (value) => {
  if (String(value).length > 64) {
    return { isValid: false, helperText: i18n.t('validation:maxLength64') };
  }
  return null;
};

const validateOnlyNumbers = (value) => {
  if (value === '' || value === undefined || value === null) {
    return null;
  }
  if (!/^\d+$/.test(String(value))) {
    return { isValid: false, helperText: i18n.t('validation:JustNumbers') };
  }
  return null;
};

const validateValidChars = (value) => {
  const regex = /^[\p{L}\p{N}\s\-_|+()'º./]+$/u;
  if (!regex.test(String(value))) {
    return { isValid: false, helperText: i18n.t('validation:validChars') };
  }
  return null;
};

const duplicated = (tableData, field, value, tableRef) => (
  checkDuplicated(tableData, field, value, tableRef) && {
    isValid: false,
    helperText: i18n.t('validation:DuplicatedRegister'),
  }
);

export const validateIdEquipament = ({ id_equipament }) => (
  validateRequired(id_equipament) || { isValid: true }
);

export const validateName = ({ name, tableData }, tableRef) => (
  validateValidChars(name)
    || validateMaxLength64(name)
    || validateRequired(name)
    || duplicated(tableData, 'name', name, tableRef)
    || { isValid: true }
);

export const validateTurnGroupId = ({ turn_group_id }) => {
  if (['', '0', 0].includes(turn_group_id)) {
    return { isValid: false, helperText: i18n.t('validation:RequiredField') };
  }
  return { isValid: true };
};

export const validateDescription = ({ description }) => (
  validateRequired(description)
    || validateMaxLength64(description)
    || { isValid: true }
);

export const validateMobileWorkflowNumber = ({ mobile_workflow_number }) => (
  validateRequired(mobile_workflow_number)
    || validateOnlyNumbers(mobile_workflow_number)
    || { isValid: true }
);
